import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { DashboardLayout } from './components/DashboardLayout';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      </div>
    </AuthProvider>
  );
}

export default App;
